import Dashboard from "./pages/Dashboard";
import Form from "./pages/Form";
import Submission from "./pages/Submission";
import FAQ from "./pages/FAQ";
import LeaguePage from "./pages/League";
import RamadanEvent from "./pages/RamadanEvent";
import EagleSubmissionPage from "./pages/EagleSubmission";
import NotFoundPage from "./pages/NotFoundPage";
import TNCEaglePage from "./pages/TNCEagle";
import LoginPage from "./pages/LoginPage";
import ProfilePage from "./pages/Profile";
import HVRTraining from "./pages/TrainingHVR";
import HVRPTraining from "./pages/TrainingPHVR";
import EagleFeedback from "./pages/EagleFeedback";
import KayuhWinnerForm from "./pages/KayuhWinnerForm";
import FeedbackSelectionPage from "./pages/FeedbackTypeSelector";
import StreaksFeedback from "./pages/StreaksFeedbackForm";  // or whatever you named the file


const AppRoutes = [
    {
        index: true,
        path: 'login',
        element: <LoginPage />
    },
    {
        path: '/',
        isPrivate: true,
        element: <ProfilePage/>
    },
    {
        path: 'league',
        isPrivate: true,
        element: <LeaguePage />
    },
    {
        path: 'submission-log',
        isPrivate: true,
        element: <EagleSubmissionPage />
    },    
    {
        path: 'tnc-improvement',
        isPrivate: true,
        element: <TNCEaglePage />

    },
    {
        path: 'hvr-training',
        isPrivate: true,
        element: <HVRTraining />

    },
    {
        path: 'premium-hvr-training',
        isPrivate: true,
        element: <HVRPTraining />

    },
    //{ Jon's version
    //    path: 'improved-feedback',
    //    isPrivate: true,
    //    element: <EagleFeedback/>

    //},
    // gautam's version
    {
        path: 'improved-feedback',  // Landing page with 2 buttons
        isPrivate: true,
        element: <FeedbackSelectionPage />
    },
    {
        path: 'eagle-feedback',  // Eagle form
        isPrivate: true,
        element: <EagleFeedback />
    },
    {
        path: 'streaks-feedback',  // Streaks form
        isPrivate: true,
        element: <StreaksFeedback />
    },
    //Gautam's version ends here
    {
        path: 'kayuh-winner',
        isPrivate: true,
        element: <KayuhWinnerForm/>
    },
    {
        path: '*',
        element: <NotFoundPage />
    }
];

export default AppRoutes;
